// src/routes/Router.js
import { lazy, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Users from "../components/pages/userResigtration/users/Users.js";
import Login from "../components/pages/Login.js";
import ProtectedRoute from "../Context/ProtectedRoute.js";
import Employee from "../components/pages/Employee/Employee.js";
import Packages from "../components/pages/userResigtration/package/Packages.js";
import Verification from "../components/pages/verificationPages/Verification.js";
import QCReports from "../components/pages/QCReports/QCReports.js";
import UserDashboard from "../components/pages/UsersPages/Dashboard/UserDashboard.js";
import CurrentWorkLoad from "../components/pages/UsersPages/WorkLoad/CurrentWorkLoad.js";
import SubmitForms from "../components/pages/UsersPages/SubmitForms/SubmitForms.js";
import UserReport from "../components/pages/UsersPages/UserReport/UserReport.js";
import ViewUserQCReports from "../components/pages/QCReports/ViewUserQCReports.js";
import PendingUsers from "../components/pages/userResigtration/pendingUsers/PendingUsers.js";
import ChangePassword from "../components/pages/ChangeAdminPassword.js";

/***** Pages ****/
const Dashboard = lazy(() => import("../components/pages/Dashboard/Dashboard.js"));

const Router = () => {

  return (
    <main>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/verification/:token" element={<Verification />} />

        {/* Admin Routes */}
        <Route path="/admin/change-password" element={<ProtectedRoute element={<ChangePassword />} allowedRoles={['admin']} />} />
        <Route
          path="/admin"
          element={<ProtectedRoute element={<Dashboard />} allowedRoles={['admin']} />}
        />
        <Route
          path="/admin/users"
          element={<ProtectedRoute element={<Users />} allowedRoles={['admin']} />}
        />
        <Route
          path="/admin/pending-users"
          element={<ProtectedRoute element={<PendingUsers />} allowedRoles={['admin']} />}
        />
        <Route
          path="/admin/package"
          element={<ProtectedRoute element={<Packages />} allowedRoles={['admin']} />}
        />
        <Route
          path="/admin/employee"
          element={<ProtectedRoute element={<Employee />} allowedRoles={['admin']} />}
        />
        <Route
          path="/admin/qc-reports"
          element={<ProtectedRoute element={<QCReports />} allowedRoles={['admin']} />}
        />
        <Route
          path="/admin/qc-reports-view/:token"
          element={<ProtectedRoute element={<ViewUserQCReports />} allowedRoles={['admin']} />}
        />


        {/* User Routes */}
        <Route
          path="/user"
          element={<ProtectedRoute element={<UserDashboard />} allowedRoles={['user']} />}
        />
        <Route
          path="/user/work-load"
          element={<ProtectedRoute element={<CurrentWorkLoad />} allowedRoles={['user']} />}
        />
        <Route
          path="/user/submited-forms"
          element={<ProtectedRoute element={<SubmitForms />} allowedRoles={['user']} />}
        />
        <Route
          path="/user/report"
          element={<ProtectedRoute element={<UserReport />} allowedRoles={['user']} />}
        />
        <Route path="*" element={<Login />} />
      </Routes>
    </main>
  );
}

export default Router;